module.exports = __webpack_public_path__ + "img/img24.b86330f7.svg";